import React from 'react'
import { useSelector } from 'react-redux'
import { Modal } from '../../../components/Modal'
import { ModalType } from '../../../states/modals/ModalType.constants'
import { SchoolListingViewAllModalItem } from './SchoolListingViewAllModalItem'

const SchoolListingViewAllModal = () => {
  const { modalType, data } = useSelector(({ modals }) => modals)
  if (modalType !== ModalType.SCHOOL_LISTING_VIEW_ALL_MODAL) {
    return null
  }

  const { listings, schoolCoords, header } = data
  return (
    <Modal header={`${header} (${listings.length})`}>
      {listings.map((l) => (
        <SchoolListingViewAllModalItem
          key={l.id}
          schoolCoords={schoolCoords}
          listing={l}
        />
      ))}
    </Modal>
  )
}

export { SchoolListingViewAllModal }
